import React from "react";

const DestinationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.73726 2.40625C6.65683 2.40625 4.1582 4.90487 4.1582 7.98531C4.1582 12.1696 9.73726 18.3464 9.73726 18.3464C9.73726 18.3464 15.3163 12.1696 15.3163 7.98531C15.3163 4.90487 12.8177 2.40625 9.73726 2.40625ZM9.73726 9.97783C8.63739 9.97783 7.74474 9.08518 7.74474 7.98531C7.74474 6.88544 8.63739 5.99279 9.73726 5.99279C10.8371 5.99279 11.7298 6.88544 11.7298 7.98531C11.7298 9.08518 10.8371 9.97783 9.73726 9.97783Z"
        fill="#100A0A"
      />
    </svg>
  );
};

export default DestinationIcon;
